<template>
  <div class="pb-4">
    <VanCellGroup inset>
      <VanField
        v-model="position.name"
        :label="$t('Chats.chatScene.edit.name')"
        :placeholder="$t('Chats.chatScene.edit.positionNamePlaceholder')"
        :rules="[
          {
            required: true,
            message: $t('Chats.chatScene.edit.positionNamePlaceholder'),
          },
        ]"
        required
        @blur="_updateChatScenePosition()"
      >
        <template #label>
          <span>
            {{ $t("Chats.chatScene.edit.name") }}
          </span>
          <!-- <i
            @click="clickNameInfo"
            class="iconfont icon-info text-xs ml-1 cursor-pointer"
          /> -->
        </template>
        <template #right-icon>
          <i
            v-if="position.id"
            class="iconfont icon-delete text-xs translate-y-1 ml-1 cursor-pointer"
            @click="clickDeletePosition"
          />
        </template>
      </VanField>
      <div class="relative flex bg-base-200 px-3 pt-2 pb-2">
        <div class="form-control w-full">
          <div class="flex w-full items-center justify-between">
            <div class="label pt-0">
              <div class="flex items-center label-text">
                {{ $t("Chats.chatScene.edit.shortDesc") }}
              </div>
            </div>
          </div>
          <textarea
            ref="textarea"
            v-model="position.shortDescription"
            :placeholder="$t('Chats.chatScene.edit.shortDescPlaceholder')"
            class="input input-bordered w-full rounded textarea min-h-[3rem] text-xs join-item text-base-content overflow-hidden"
            @blur="_updateChatScenePosition()"
          />
        </div>
      </div>

      <div class="relative flex bg-base-200 px-3 pb-2">
        <div class="form-control w-full">
          <div class="flex w-full items-center justify-between">
            <div class="label pt-0">
              <div class="flex items-center label-text">
                {{ $t("Chats.chatScene.edit.enterCondition") }}
              </div>
            </div>
          </div>
          <textarea
            ref="textarea"
            v-model="position.enterCondition"
            :placeholder="$t('Chats.chatScene.edit.enterConditionPlaceholder')"
            class="input input-bordered w-full rounded textarea min-h-[3rem] text-xs join-item text-base-content overflow-hidden"
            @blur="_updateChatScenePosition()"
          />
        </div>
      </div>

      <div class="relative flex bg-base-200 px-3 pb-2">
        <div class="form-control w-full">
          <div class="flex w-full items-center justify-between">
            <div class="label pt-0">
              <div class="flex items-center label-text">
                {{ $t("Chats.chatScene.edit.leavingCondition") }}
              </div>
            </div>
          </div>
          <textarea
            ref="textarea"
            v-model="position.leavingDefinition"
            :placeholder="
              $t('Chats.chatScene.edit.leavingConditionPlaceholder')
            "
            class="input input-bordered w-full rounded textarea min-h-[3rem] text-xs join-item text-base-content overflow-hidden"
            @blur="_updateChatScenePosition()"
          />
        </div>
      </div>

      <div class="relative flex bg-base-200 px-3 pb-2 w-full">
        <div class="form-control w-full">
          <div class="flex w-full items-center justify-between">
            <div class="label pt-0">
              <div class="flex items-center label-text">
                {{ $t("Chats.chatScene.edit.connectLocation") }}
              </div>
            </div>
          </div>
          <div class="flex items-center flex-wrap gap-2">
            <VanTag
              v-for="location in position.destinationzz || []"
              :key="location.id"
              closeable
              class="badge badge-outline"
              @close="removeDestinationConnect(location.id!)"
            >
              {{ location.name }}
            </VanTag>

            <!-- <button
              class="btn btn-xs "
              @click="clickAddDestinationConnect()"
            >
              <i class="iconfont icon-a-" />
              <span>{{ $t("Buttons.add") }}</span>
            </button> -->
          </div>

          <div class="flex justify-end pr-4">
            <button
              class="btn btn-sm btn-neutral text-base-content/50 gap-0"
              @click="clickAddDestinationConnect"
            >
              <i class="iconify mdi--plus text-xs" />
              {{ $t("Buttons.add") }}
            </button>
          </div>
        </div>
      </div>

      <div class="relative bg-base-200 px-3 pb-2">
        <div class="form-control w-full">
          <div class="flex w-full items-center justify-between">
            <div class="label pt-0">
              <div class="flex items-center label-text">
                {{ $t("Chats.chatScene.edit.containCharacter") }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap gap-2 my-2">
          <div
            class="flex flex-col items-center gap-0.5 relative"
            v-for="character in position.characterzz"
            :key="character.id"
          >
            <i
              class="iconfont icon-close absolute top-[-8px] right-[-8px] z-10 text-xs bg-base-100 rounded-full cursor-pointer"
              @click="removeCharacter(character.id!)"
            />
            <UserAvatar
              class="w-16"
              :avatar-url="mateStore.mateIdMap.get(character.mateId)?.mediaUrl"
            />
            <div class="text-xs max-w-16 line-clamp-1">
              {{
                character.role === 2
                  ? $t("game.player")
                  : mateStore.mateIdMap.get(character.mateId)?.name
              }}
            </div>
          </div>
        </div>

        <div class="flex justify-end pr-4">
          <button
            class="btn btn-sm btn-neutral text-base-content/50 gap-0"
            @click="clickAddCharacter()"
          >
            <i class="iconify mdi--plus text-xs" />
            {{ $t("Buttons.add") + " " + $t("Chats.chatScene.edit.character") }}
          </button>
        </div>
      </div>

      <!-- <div class="relative bg-base-200 px-3 pb-2" v-if="!position.parentId">
        <div class="form-control w-full">
          <div class="flex w-full items-center justify-between">
            <div class="label pt-0">
              <div class="flex items-center label-text">
                {{ $t("Chats.chatScene.edit.childrenPosition") }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-2 pl-6 pr-4">
          <div
            v-for="(d, idx) in position.positionzz! || []"
            :key="idx"
            class="flex gap-2 justify-between items-center w-full overflow-hidden"
          >
            <div class="break-words flex-1">
              {{ d.name }} : {{ d.shortDescription }}
            </div>
            <div>
              <button
                class="btn btn-xs btn-neutral text-base-content/50 gap-0"
                @click="clickEditPosition(d, position.parentId)"
              >
                <i class="iconify mdi--pencil-outline text-xs" />
              </button>
            </div>
          </div>
        </div>

        <div class="flex justify-end pr-4">
          <button
            class="btn btn-sm btn-neutral text-base-content/50 gap-0"
            @click="clickEditPosition(undefined, position.id)"
          >
            <i class="iconify mdi--plus text-xs" />
            {{ $t("Buttons.add") }}
          </button>
        </div>
      </div> -->
    </VanCellGroup>

    <ModalSelectOption
      v-model:show="showSelectDestinationModal"
      :options="options"
      :title="$t('Chats.chatScene.edit.selectDestination')"
      @confirm="onSelectDestination"
    />

    <ModalSelectCharacter
      v-model:show="showCharacterSelectPopup"
      :selected-ids="[
        ...(props.position.characterzz?.map((c) => c.id!) || []),
      ]"
      :character-list="characterList"
      @select="onSelectCharacter"
    />

    <ModalChatScenePositionEdit
      v-if="!position.parentId && activePosition"
      v-model:show="showPositionEditPopup"
      :position="activePosition"
      :chat-scene="chatScene"
      @close-edit-modal="showPositionEditPopup = false"
    />
  </div>
</template>
<script setup lang="ts">
import {
  createOneChatScenePosition,
  deleteOneChatScenePosition,
  updateOneChatScenePosition,
} from "@/apis/chat";
import { useChatScene } from "@/stores/chatScene";
import { useMate } from "@/stores/mate";
import { ChatScene, ChatSceneCharacter, ChatScenePosition } from "@/types/chat";
import { showConfirmDialog } from "vant";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  position: ChatScenePosition;
  chatScene: ChatScene;
}>();

const chatSceneStore = useChatScene();
const mateStore = useMate();
const { t } = useI18n();

const emit = defineEmits<{
  (e: "closeEditModal"): void;
}>();

const _updateChatScenePosition = (parentPosition?: ChatScenePosition) => {
  chatSceneStore.withSaving(async () => {
    if (!props.position.id && props.position.parentId) {
      const res = await createOneChatScenePosition(props.position);
      if (res.code === 200) {
        Object.assign(props.position, res.item);
      }

      const _parentPosition = props.chatScene.positionzz?.find(
        (v) => v.id === props.position.parentId
      );
      if (_parentPosition) _parentPosition.positionzz?.push(props.position);
    } else if (parentPosition) {
      updateOneChatScenePosition(parentPosition);
    } else {
      return updateOneChatScenePosition(props.position);
    }
  });
};

const clickDeletePosition = () => {
  const { parentId, id } = props.position;
  let msgTitle = !parentId
    ? t("Chats.chatScene.edit.deleteParentPositionConfirm")
    : t("Message.deleteConfirm");

  showConfirmDialog({
    title: msgTitle,
    confirmButtonText: t("Buttons.confirm"),
    cancelButtonText: t("Buttons.cancel"),
  }).then(() => {
    if (parentId) {
      const parentPosition = props.chatScene.positionzz?.find(
        (v) => v.id === parentId
      );
      if (parentPosition)
        parentPosition.positionzz = parentPosition.positionzz?.filter(
          (v) => v.id !== id
        );
      emit("closeEditModal");
    } else {
      props.chatScene.positionzz = props.chatScene.positionzz?.filter(
        (v) => v.id !== id
      );
    }
    chatSceneStore.withSaving(() =>
      deleteOneChatScenePosition(props.position.id!)
    );
  });
};

const showSelectDestinationModal = ref(false);
const options = ref<{ text: string; value: string }[]>([]);
const clickAddDestinationConnect = () => {
  const { parentId } = props.position;
  const { positionzz } = props.chatScene;
  if (!positionzz?.length) return;

  const alreadyAddedPositionIds: Record<number, boolean> = {};
  props.position.destinationzz?.forEach(
    (destination) => (alreadyAddedPositionIds[destination.id!] = true)
  );
  let positions: ChatScenePosition[] = [];
  if (!parentId) {
    // 添加第一层的位置
    // 找到第一层位置的所有子位置
    positions = positionzz.filter(
      (position) =>
        !position.parentId &&
        !alreadyAddedPositionIds[position.id!] &&
        position.id !== props.position.id
    );
  } else {
    if (!props.position.name) {
      return showConfirmDialog({
        title: t("Chats.chatScene.edit.pleaseAddNameFirst"),
        confirmButtonText: t("Buttons.confirm"),
        showCancelButton: false,
      });
    }
    // 添加到指定位置
    // 1. 获取所有父级连接位置 destinationzz
    // 2. 遍历父级连接位置，获取所有子位置
    const parentPosition = props.chatScene.positionzz?.find(
      (v) => v.id === parentId
    );
    if (parentPosition)
      parentPosition.destinationzz!.forEach((v) => {
        const targetPosition = positionzz.find((p) => p.id === v.id);
        targetPosition?.positionzz?.forEach((p) => {
          if (!alreadyAddedPositionIds[p.id!]) positions.push(p);
        });
      });
  }

  if (positions.length <= 0) {
    return showConfirmDialog({
      title: t("Chats.chatScene.edit.noOtherPosition"),
      confirmButtonText: t("Buttons.confirm"),
      showCancelButton: false,
    });
  }

  options.value = positions.map((position) => ({
    text: position.name,
    value: `${position.parentId || ""}-${position.id}`,
  }));
  showSelectDestinationModal.value = true;
};

const removeDestinationConnect = (id: number) => {
  const { parentId } = props.position;
  let msgTitle = !parentId
    ? t("Chats.chatScene.edit.deleteParentDestinationConfirm")
    : t("Message.deleteConfirm");

  showConfirmDialog({
    title: msgTitle,
    confirmButtonText: t("Buttons.confirm"),
    cancelButtonText: t("Buttons.cancel"),
  }).then(() => {
    if (!parentId) {
      // 遍历子位置，删除目标位置
      props.position.positionzz!.forEach((childPosition) => {
        childPosition.destinationzz = childPosition.destinationzz?.filter(
          (c) => c.parentId !== id
        );
      });
    }
    props.position.destinationzz = props.position.destinationzz?.filter(
      (c) => c.id !== id
    );
    _updateChatScenePosition();
  });
};

const onSelectDestination = (value: string) => {
  const [parentId, id] = value.split("-");
  let destination: ChatScenePosition | undefined;
  if (parentId) {
    const parentPosition = props.chatScene.positionzz!.find(
      (v) => v.id === Number(parentId)
    );
    destination = parentPosition!.positionzz!.find((v) => v.id === Number(id));
  } else {
    destination = props.chatScene.positionzz!.find((v) => v.id === Number(id));
  }
  if (destination) props.position.destinationzz?.push(destination);
  _updateChatScenePosition();
  showSelectDestinationModal.value = false;
};

// select character
const showCharacterSelectPopup = ref(false);
const characterList = ref<ChatSceneCharacter[]>([]);

const clickAddCharacter = () => {
  const characterMap = new Map<number, ChatSceneCharacter>();
  props.chatScene.characterzz?.forEach((v) => {
    characterMap.set(v.id!, v);
  });

  if (props.position.parentId) {
    if (!props.position.name) {
      return showConfirmDialog({
        title: t("Chats.chatScene.edit.pleaseAddNameFirst"),
        confirmButtonText: t("Buttons.confirm"),
        showCancelButton: false,
      });
    }
    const parentPosition = props.chatScene.positionzz?.find(
      (v) => v.id === props.position.parentId
    );
    if (parentPosition)
      characterList.value = parentPosition.characterzz!.map(
        (v) => characterMap.get(v.id!)!
      );
  } else {
    characterList.value = props.chatScene.characterzz!;
  }
  if (characterList.value.length <= 0)
    return showConfirmDialog({
      title: t("Chats.chatScene.edit.pleaseAddCharacter"),
      confirmButtonText: t("Buttons.confirm"),
      showCancelButton: false,
    });
  showCharacterSelectPopup.value = true;
};

const onSelectCharacter = (value: ChatSceneCharacter) => {
  props.position.characterzz?.push(value);
  _updateChatScenePosition();
  showCharacterSelectPopup.value = false;
};

const removeCharacter = (id: number) => {
  const { parentId, positionzz } = props.position;
  const msgTitle = !parentId
    ? t("Chats.chatScene.edit.deleteParentCharacterConfirm")
    : t("Message.deleteConfirm");

  showConfirmDialog({
    title: msgTitle,
    confirmButtonText: t("Buttons.confirm"),
    cancelButtonText: t("Buttons.cancel"),
  }).then(() => {
    if (!parentId && positionzz?.length) {
      positionzz.forEach((v) => {
        v.characterzz = v.characterzz?.filter((c) => c.id !== id);
      });
    }
    props.position.characterzz = props.position.characterzz?.filter(
      (c) => c.id !== id
    );
    _updateChatScenePosition();
  });
};

// position edit
const showPositionEditPopup = ref(false);
const activePosition = ref<ChatScenePosition>();
const clickEditPosition = (position?: ChatScenePosition, parentId?: number) => {
  activePosition.value =
    position ||
    ({
      parentId: parentId,
    } as ChatScenePosition);
  if (!position) activePosition.value.chatSceneId = props.chatScene.id!;

  showPositionEditPopup.value = true;
};
</script>
